// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAwardCustomUpdateBody = {
  poolId: string;
  awardTypeId: string;
  name?: string | null;
  color?:
    | "color1"
    | "color2"
    | "color3"
    | "color4"
    | "color5"
    | "color6"
    | "color7"
    | "color8"
    | null;
};

export type typeAwardCustomUpdateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isUpdated: boolean };
};

export type typeAwardCustomUpdateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomUpdateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomUpdateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAwardCustomUpdateBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    awardTypeId: { type: "string", maxLength: 3000, minLength: 1 },
    name: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    color: {
      oneOf: [
        {
          type: "string",
          enum: [
            "color1",
            "color2",
            "color3",
            "color4",
            "color5",
            "color6",
            "color7",
            "color8",
          ],
        },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId", "awardTypeId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAwardCustomUpdate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAwardCustomUpdateBody);
  }

  return async function postAwardCustomUpdate(
    payload: typeAwardCustomUpdateBody,
  ): Promise<typeAwardCustomUpdateOutput200 | typeAwardCustomUpdateOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAwardCustomUpdate" failed before calling the network. #216dc798c146`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#216dc798c146" },
        },
        data: null,
      } as typeAwardCustomUpdateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/award/custom-update`,
      httpMethod: "POST",
      options,
    })) as typeAwardCustomUpdateOutput200 | typeAwardCustomUpdateOutput400;
  };
}
